import React from "react";
import { injectIntl } from "react-intl";
import moment from "moment";
import {
  ID_PAZIENTE,
  DATA_INTERVENTO,
  INGRESSO_BLOCCO_OPERATORIO,
  INGRESSO_SALA_OPERATORIA,
  USCITA_SALA_OPERATORIA,
  USCITA_BLOCCO_OPERATORIO,
} from "../../../modules/surgery";
import {
  STATO_NON_DISPONIBILE,
  STATO_INTERVENTO_PIANIFICATO,
  STATO_IN_BLOCCO_OPERATORIO,
  STATO_INTERVENTO_IN_CORSO,
  STATO_INTERVENTO_POST_OPERATORIO,
  STATO_INTERVENTO_TERMINATO,
} from "../../../modules/language";
import { getMessageString } from "../../../tools";

const StatoOperazioneBase = ({ info, intl }) => {
  // const StatoOperazioneBase = ({ intl }) => {
  // const info = {
  //   idPaziente: "12345678",
  //   dataIntervento: "2021-11-04",
  //   ingressoBloccoOperatorio: "11:34",
  //   ingressoSalaOperatoria: "12:34",
  //   uscitaSalaOperatoria: "02:34",
  //   uscitaBloccoOperatorio: "03:34",
  // };

  const getStatoOperazione = () => {
    let stato = STATO_NON_DISPONIBILE;
    let classe = "nonIniziatoLabel";
    if (!info[ID_PAZIENTE] || info[ID_PAZIENTE] === undefined) {
      stato = STATO_NON_DISPONIBILE;
      classe = "nonIniziatoLabel";
    } else {
      if (
        (!info[INGRESSO_BLOCCO_OPERATORIO] || info[INGRESSO_BLOCCO_OPERATORIO] === undefined) &&
        (!info[INGRESSO_SALA_OPERATORIA] || info[INGRESSO_SALA_OPERATORIA] === undefined) &&
        (!info[USCITA_SALA_OPERATORIA] || info[USCITA_SALA_OPERATORIA] === undefined) &&
        (!info[USCITA_BLOCCO_OPERATORIO] || info[USCITA_BLOCCO_OPERATORIO] === undefined)
      ) {
        if (info[DATA_INTERVENTO] && info[DATA_INTERVENTO] !== undefined) stato = STATO_INTERVENTO_PIANIFICATO;
        else stato = STATO_INTERVENTO_PIANIFICATO;
        classe = "nonAncoraIniziatoLabel";
      }
      if (info[INGRESSO_BLOCCO_OPERATORIO] && info[INGRESSO_BLOCCO_OPERATORIO] !== undefined) {
        stato = STATO_IN_BLOCCO_OPERATORIO;
        classe = "inBloccoOperatorioLabel";
      }
      if (info[INGRESSO_SALA_OPERATORIA] && info[INGRESSO_SALA_OPERATORIA] !== undefined) {
        stato = STATO_INTERVENTO_IN_CORSO;
        classe = "interventoInCorsoLabel";
      }
      if (info[USCITA_SALA_OPERATORIA] && info[USCITA_SALA_OPERATORIA] !== undefined) {
        stato = STATO_INTERVENTO_POST_OPERATORIO;
        classe = "interventoPostOperatorioLabel";
      }
      if (info[USCITA_BLOCCO_OPERATORIO] && info[USCITA_BLOCCO_OPERATORIO] !== undefined) {
        stato = STATO_INTERVENTO_TERMINATO;
        classe = "interventoTerminatoLabel";
      }
    }
    return { classe, stato };
  };

  return (
    <span className={"labelStato " + getStatoOperazione().classe}>
      {getMessageString(intl, getStatoOperazione().stato)}
      {getStatoOperazione().stato === STATO_INTERVENTO_PIANIFICATO && (
        <span style={{ textTransform: "capitalize" }}>{moment(info[DATA_INTERVENTO]).format("dddd D MMMM YYYY")}</span>
      )}
    </span>
  );
};
export const StatoOperazione = injectIntl(StatoOperazioneBase);
